import React from "react";
import CONFIG from "../../../../config";

import koronaLogo from '../../../../assets/img/where-pay/korona-logo.svg';

const { LINKS } = CONFIG;

const CrownItem: React.FC = () => (
    <div className="where__pay__item">
        <div className="where__pay__title korona">
            <img src={koronaLogo} alt="РНКО “Платежный Центр” (ООО)" />
            <span>РНКО “Платежный Центр” (ООО)</span>
        </div>
        <div className="where__pay__link">
            <a href={LINKS.KORONA.REPAYMENT} target="_blank" rel="noopener noreferrer nofollow">В платежных сервисах</a>
            <ul>
                <li><span>Комиссия 0,99% (мин. сумма 50 ₽)</span></li>
                <li><span>Зачисление на следующий рабочий день</span></li>
            </ul>
        </div>
    </div>
);

export default CrownItem;